import navClasses from "../../../css/modules/navigation.module.scss";
import classes from "../../../css/modules/navigation.module.scss";
import { Link } from "react-router-dom";
import { routes } from "../../../utils/constants";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { IconButton } from "@mui/material";
import { MenuContent } from "../../../components/Header/MenuContent";
import { pageTitle, selectors } from "../../../redux/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import { HelpButton } from "../../../components/HelpButton";
import { useTranslation } from "react-i18next";

export function DepartmentHeader() {
    const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
    const { t } = useTranslation();

  const toggle = () => setSidebarIsOpen(!sidebarIsOpen);
  const onLocationChange = () => {
    setSidebarIsOpen(false);
  };
  const dispatch = useDispatch();
  const title = useSelector(selectors.get);

  useEffect(() => {
    document.title = t("Department overview") + " | Project Assistant";
    dispatch(pageTitle.actions.change(""))
    return () => {
      dispatch(pageTitle.actions.change(""))
    };
  }, [dispatch, t]);  
  
  return <>
    <header className={clsx(navClasses.header, navClasses.departmentHeader)}>
      <IconButton
        className={classes.burgerMenu}
        onClick={toggle}
        edge="start"
        color="inherit"
        aria-label="menu"
        data-testid="mn_menu_icon"
        size="large">
        <span
          className={clsx({
            ico: true,
            "icon-menu": !sidebarIsOpen,
            "icon-cross": sidebarIsOpen,
          })}
        ></span>
      </IconButton>
      <div className={navClasses.container}>
        <Link to={routes.projects} className={navClasses.headerTitle}>
          <img src={"/logo.jpg"} alt="Logo" height="29" />
        </Link>
      </div>
      <span className={classes.pageTitle} data-testid="mn_menu_pagetitle">
      <span>{t("Department overview")} <br />{title}</span>
      </span>
      <div id="header-inject-zone" className={navClasses.inject} />
      <HelpButton/>
    </header>
    <div className={clsx(classes.sidebarDrawer, sidebarIsOpen && classes.open)}>
      <MenuContent onLocationChange={onLocationChange} />
    </div>
  </>;
}
